
import { useRef, useState } from "react";
import Layout from "../../components/mainPage/Layout";
import video from "../../images/imagePopup/visualInformation/topologyProcessor.webm";
import { VideoSide } from "../../components/popup/VideoSide";
export const Page = () => {
    const vidRef = useRef(null);
    const [isPlayButton, setIsPlayButton] = useState(true);
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    Топологический анализ
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        <b>Топологический анализ</b> на базе CIM (Common Information Model) в сочетании со SCADA NPT Expert, которая отвечает за сбор данных и управление процессами, является важным инструментом для повышения эффективности и надежности энергосистем.
                    </p>

                    <VideoSide
                        isOpen={true}
                        active={true}
                        vidRef={vidRef}
                        image={video}
                        setIsPlayButton={setIsPlayButton}
                        isPlayButton={isPlayButton}
                        width={"100%"}
                    />

                    <p>Основные задачи, которые он позволяет решать, включают:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li"><b>Моделирование и визуализация энергосистем</b>
                            <ul>
                                <li>Топологический анализ на базе CIM позволяет создавать точные модели энергосистем, включая их структуру, оборудование и связи между элементами. За счет собранных данных о состоянии КА SCADA NPT Expert обеспечивает визуализацию сети в реальном времени, что помогает операторам лучше понимать текущее состояние системы.
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Оптимизация управления сетью</b>
                            <ul>
                                <li>Топологический анализ помогает оптимизировать управление сетью, предоставляя данные для:
                                    <ul>
                                        <li>Перераспределения нагрузки.</li>
                                        <li>Планирования переключений.</li>
                                        <li>Минимизации потерь энергии.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Поддержка принятия решений</b>
                            <ul>
                                <li>На основе топологического анализа SCADA NPT Expert может выполнять блокировку ошибочных действий оператора и предоставлять следующие рекомендации:
                                    <ul>
                                        <li>Оптимальные схемы переключений.</li>
                                        <li>Прогнозирование последствий аварий.</li>
                                        <li>Планирование ремонтных работ.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Повышение надежности и безопасности</b>
                            <ul>
                                <li>Топологический анализ помогает выявлять слабые места в сети, такие как:
                                    <ul>
                                        <li>Перегруженные участки.</li>
                                        <li>Узкие места в передаче энергии.</li>
                                        <li>Потенциальные точки отказа.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Автоматизация процессов</b>

                            <ul>
                                <li>Обнаружение и локализация аварий.</li>
                                <li>Восстановление питания после сбоев.</li>
                                <li>Управление режимами работы сети.</li>
                            </ul>

                        </li>
                        <li className="mb-1 description__number-li"><b>Упрощение модернизации и расширения сети</b>
                            <ul>
                                <li>Топологический анализ на базе CIM обеспечивает гибкость при модернизации и расширении сети, так как:
                                    <ul>
                                        <li>Позволяет легко добавлять новые элементы в модель.</li>
                                        <li>Обеспечивает совместимость с новым оборудованием.</li>
                                        <li>Упрощает интеграцию новых технологий (например, возобновляемых источников энергии) .</li>
                                    </ul>
                                </li>

                            </ul>
                        </li>
                    </ul>

                </div>

            </div>
        </div>
    </Layout>
}